'use strict';

var toString = require('../string/to-string');

/**
 * Aggiunge i separatori per i decimali
 * @param value
 * @param precision
 * @param preserveLeftZero
 * @returns {string}
 */
module.exports = function setDecimalFormat(value, precision, preserveLeftZero) {
    var pair = toString(value).split(','),
        hasComma = pair.length > 1,
        number = pair[0],
        sDec = pair.slice(1).join(''),
        leftZero = '';

    //rendo la stringa di soli numeri
    number = number.replace(/[^0-9]/g, '');

    if (preserveLeftZero) {
        leftZero = number.match(/^0+/g);
    }

    //rimuovo i primi caratteri se 0
    number = number.replace(/^0+/g, '');

    //la formatto in migliaia 1.234
    number = number.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (precision && precision > 0) {
        sDec = sDec.replace(/[^0-9]/g, '');

        if (precision !== true) {
            sDec = sDec.slice(0, precision);

            if(number){
                while (sDec.length < precision) {
                    sDec += 0;
                }
            }
        }

        if(sDec || hasComma){
            number += ',' + sDec;
        }
    }

    if (leftZero) {
        number = leftZero + number;
    }

    return number;
};
